// extracted by mini-css-extract-plugin
module.exports = {"Icon":"icon_Icon__YcL6A"};